import Vue from 'vue';
import addressupdateVueModelSchema from './addressupdate.vue.model.schema';
import AutomationReactivationVM from './reactivation.vue.model';

export default class AutomationAdressupdateVM extends AutomationReactivationVM {
  override async initialize(): Promise<void> {
    this.formReactivationModel.schema = addressupdateVueModelSchema;
    super.initialize();
  }
  override async submitForm() {
    this.isSubmitting = true;
    try {
      if (!this.formReactivationModel.validate()) {
        this.isSubmitting = false;
        return;
      }
      if (this.formReactivationModel.newsletterItems !== undefined && this.formReactivationModel.newsletterItems?.length > 0) {
        if (this.formReactivationModel.contact.email === undefined || this.formReactivationModel.contact.email === '') {
          this.isSubmitting = false;
          this.error = Vue.$t('widget.automation.submitValidationEmailMissing'); // hackyhack: 'E-Mail: Muss ausgefüllt werden';
          return;
        }
      }
      this.formReactivationModel.languageIso2 = Vue.$translation.get() ?? Vue.$config.values['language-default'];
      this.formReactivationModel.contactId = this.contactId;
      this.formReactivationModel.tenantKey = this.tenantKey;
      const req = this.formReactivationModel;
      await Vue.$service.v2.api.addressUpdate.postAddressUpdateFormPayload(req);
      this.isSubmitted = true;
    } catch (error: any) {
      this.error = error;
    }
    this.isSubmitting = false;
  }
}
